import {
  MARITALTAX_LOADING,
  GET_MARITALTAX,
  GET_MARITALTAX_SUCCESS,
  GET_MARITALTAX_FAIL,
  ADD_MARITALTAX_SUCCESS,
  ADD_MARITALTAX_FAIL,
  DELETE_MARITALTAX_SUCCESS,
  DELETE_MARITALTAX_FAIL,
  UPDATE_MARITALTAX_SUCCESS,
  UPDATE_MARITALTAX_FAIL,
  MARITALTAX_RESET
} from "./actionType";

const INIT_STATE = {
  maritalTaxs: [],
  error: {},
};

const MaritalTax = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MARITALTAX_SUCCESS:
      switch (action.payload.actionType) {
        case GET_MARITALTAX:
          return {
            ...state,
            maritalTaxs: action.payload.data,
            isMaritalTaxCreated: false,
            isMaritalTaxSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_MARITALTAX_FAIL:
      switch (action.payload.actionType) {
        case GET_MARITALTAX_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isMaritalTaxCreated: false,
            isMaritalTaxSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_MARITALTAX: {
      return {
        ...state,
        isMaritalTaxCreated: false,
        loading: true,
      };
    }

    case MARITALTAX_LOADING: {
      return {
        ...state,
        isMaritalTaxCreated: false,
        loading: true,
      };
    }

    case ADD_MARITALTAX_SUCCESS:
      return {
        ...state,
        isMaritalTaxCreated: true,
        loading: false,
        maritalTaxs: [action.payload.data, ...state.maritalTaxs],
      };

    case ADD_MARITALTAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_MARITALTAX_SUCCESS:
      return {
        ...state,
        loading: false,
        maritalTaxs: state.maritalTaxs.filter(
          maritalTax => maritalTax.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_MARITALTAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_MARITALTAX_SUCCESS:
      return {
        ...state,
        loading: false,
        maritalTaxs: state.maritalTaxs.map(maritalTax =>
          maritalTax.id.toString() === action.payload.data.id.toString() ? { ...maritalTax, ...action.payload.data } : maritalTax
        ),
      };

    case UPDATE_MARITALTAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case MARITALTAX_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default MaritalTax;